<template>
  <v-btn-dialog-action-CTA :loading="loading" :color="deleteMode ? 'error' : undefined" @click="action()">
    <template #loader>
      <v-progress-circular indeterminate :size="20" :width="3"></v-progress-circular>
      <span class="pl-2">{{ text }}</span></template
    >
    <template #prepend>
      <v-icon v-if="prependIcon">{{ prependIcon }}</v-icon>
    </template>
    {{ text }}</v-btn-dialog-action-CTA
  >
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    action: () => Promise<void> | void;
    loading: boolean;
    text?: string;
    prependIcon?: string;
    deleteMode?: boolean;
  }>(),
  { text: "Loading ...", prependIcon: undefined, deleteMode: false }
);
</script>
